import { Box, Typography } from '@mui/material'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { useAppTheme } from '@/theme/ThemeContext'

/** "משימה חדשה" button shared by the site CRM page and the consumer CRM tab. */
const NewTaskButton = ({
  onClick,
  marginTop = '30px',
}: {
  onClick: () => void
  marginTop?: string
}) => {
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'

  const BUTTON_BG = isDarkMode ? '#202B40' : '#E3F5FF'
  const TEXT_COLOR = isDarkMode ? '#FFFFFF' : '#003F61'

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '137px',
        justifyContent: 'center',
        height: '38px',
        padding: '0 16px',
        gap: '12px',
        flexShrink: 0,
        background: BUTTON_BG,
        marginTop,
        cursor: 'pointer',
        borderRadius: '4px',
      }}
      onClick={onClick}
    >
      <Typography
        sx={{
          fontFamily: 'Rubik, sans-serif',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 300,
          lineHeight: '100%',
          color: TEXT_COLOR,
        }}
      >
        משימה חדשה
      </Typography>
      <AddCircleOutlineIcon
        sx={{ color: TEXT_COLOR, width: '16px', height: '17px' }}
      />
    </Box>
  )
}

export default NewTaskButton
